omadapp.singletons.utils = new(function() {
	var t = this
	t.object2Array = object2Array
	t.cloneObject = cloneObject
	
	function object2Array (obj) {
		var  res = []
		for (var n in obj) {
			res.push (obj[n])
		}
		return res
	}

	function cloneObject (obj) {
		var res = JSON.stringify(obj)
		res = JSON.parse (res)
		return res
	}
})